import useIPA from '@/auth/jwt/useDevice'
import useRevamp from '@/auth/jwt/useRevampJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  devicelist: 1,
  perPage: 10,
  pageOptions: [10, 25, 50, 100],
  totalRows: 1,
  totalActive: 1,
  totalOffline: 1,
  totalError: 1,
  options: [],
  sortOptions: [],
  filteredDevices: [],
  filteredOptions: [],
  fieldsSparing: [
    { key: 'no', label: 'no', sortable: true },
    { key: 'name', label: 'device name', sortable: true },
    { key: 'code', label: 'device code', sortable: true },
    { key: 'serial_number', label: 'device SN', sortable: true },
    { key: 'device_type_name', label: 'Type', sortable: false },
    { key: 'note', label: 'note', sortable: true },
    { key: 'status', label: 'Status', sortable: false },
    { key: 'action', label: 'Action' },
  ],
  fields: [
    { key: 'no', label: 'no', sortable: true },
    { key: 'code', label: 'device code', sortable: true },
    { key: 'serial_number', label: 'device SN', sortable: true },
    { key: 'msisdn', label: 'msisdn', sortable: true },
    { key: 'device_type_name', label: 'Type', sortable: true },
    { key: 'note', label: 'note', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  filteredFields: [
    { key: 'is_check', label: 'Check', sortable: false },
    { key: 'no', label: 'No', sortable: false },
    { key: 'name', label: 'Name', sortable: false },
    { key: 'code', label: 'Code', sortable: false },
    { key: 'note', label: 'Note', sortable: false },
    { key: 'serial_number', label: 'Serial Number', sortable: false },
    { key: 'device_types.name', label: 'Type', sortable: false },
    { key: 'provider_cards.iccid', label: 'iccid', sortable: false },
    { key: 'provider_cards.msisdn', label: 'msisdn', sortable: false },
    { key: 'latitude', label: 'latitude', sortable: false },
    { key: 'longitude', label: 'longitude', sortable: false },
    { key: 'status', label: 'Status', sortable: false },
    { key: 'device_status', label: 'Device Status', sortable: false },
    { key: 'installation_status', label: 'Installation Status', sortable: false },
    { key: 'value', label: 'Value', sortable: false },
    { key: 'default_unit', label: 'Default Unit', sortable: false },
    { key: 'signal_type', label: 'Signal Type', sortable: false },
    { key: 'signal_strength', label: 'Signal Strength', sortable: false },
    { key: 'last_online_device', label: 'Last Online Device', sortable: false },
    { key: 'last_get_data', label: 'Last Get Data', sortable: false },
    { key: 'last_send_data', label: 'Last Send Data', sortable: false },
    { key: 'is_offline_alarm', label: 'Is Offline Alarm', sortable: false },
    { key: 'is_over_limit_max', label: 'Is Over Limit Max', sortable: false },
    { key: 'is_over_limit_min', label: 'Is Over Limit Min', sortable: false },
    { key: 'is_probe_fault', label: 'Is Probe Fault', sortable: false },
    { key: 'is_power_low', label: 'Is Power Low', sortable: false },
    { key: 'is_power_shutdown', label: 'Is Power Shutdown', sortable: false },
    { key: 'is_power_disconnect', label: 'Is Power Disconnect', sortable: false },
    { key: 'value_power', label: 'Value Power', sortable: false },
    { key: 'locations.areas.sites.name', label: 'Sites → Name', sortable: false },
    { key: 'locations.areas.sites.code', label: 'Sites → Code', sortable: false },
    { key: 'locations.areas.sites.region_provinces.name', label: 'Province Name', sortable: false },
    { key: 'locations.areas.sites.region_regencies.name', label: 'Regency Name', sortable: false },
    { key: 'locations.areas.sites.region_districts.name', label: 'District Name', sortable: false },
    { key: 'action', label: 'Action' },
  ],
  serviceFields: [
    { key: 'is_check', label: 'Check', sortable: false },
    { key: 'no', label: 'No', sortable: false },
    { key: 'name', label: 'Name', sortable: false },
    { key: 'code', label: 'Code', sortable: false },
    { key: 'serial_number', label: 'Serial Number', sortable: false },
    { key: 'device_types.name', label: 'Type', sortable: false },
    { key: 'status', label: 'Status', sortable: false },
    { key: 'service_status', label: 'Service Status', sortable: false },
    { key: 'service_start_date', label: 'Service Start Date', sortable: true },
    { key: 'service_end_date', label: 'Service End Date', sortable: true },
    { key: 'installation_status', label: 'Installation Status', sortable: false },
    { key: 'locations.areas.sites.name', label: 'Sites → Name', sortable: false },
    { key: 'locations.areas.sites.code', label: 'Sites → Code', sortable: false },
    { key: 'locations.areas.sites.region_provinces.name', label: 'Province Name', sortable: false },
    { key: 'locations.areas.sites.region_regencies.name', label: 'Regency Name', sortable: false },
  ],
  items: [],
  deviceItems: [],
  formula: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'device_name', label: 'device name', sortable: true },
      { key: 'condition', label: 'condition', sortable: true },
      { key: 'operator', label: 'operator', sortable: true },
      { key: 'value', label: 'value', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action' },
    ],
    items: [],
  },
  value: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'devices.name', label: 'device name', sortable: true },
      { key: 'name', label: 'name', sortable: true },
      { key: 'devices.description', label: 'description', sortable: true },
      { key: 'action', label: 'Action' },
    ],
    items: [],
  },
  key: {
    perPage: 10,
    pageOptions: [10, 25, 50, 100],
    totalRows: 1,
    options: [],
    sortOptions: [],
    fields: [
      { key: 'no', label: 'no', sortable: true },
      { key: 'device_values.devices.name', label: 'device name', sortable: true },
      { key: 'device_values.name', label: 'device value name', sortable: true },
      { key: 'key', label: 'key', sortable: true },
      { key: 'value', label: 'value', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action' },
    ],
    items: [],
  },
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      const orderBy = params?.orderBy ? `&orderBy=${params.orderBy}` : ''
      const param = {
        status: `master/devices?page=${params.page}&limit=${params.limit}${orderBy}`,
      }
      useIPA.get(param).then(response => {
        const DeviceList = {
          rows: response.data.data,
          pagination: response.data.pagination
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setData', { ...DeviceList })
      })
    })
  },
  getFilteredStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      const param = {
        status: 'master/devices?status=IN',
      }
      useIPA.get(param).then(response => {
        const DeviceList = {
          rows: response.data.data,
          pagination: response.data.pagination
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setData', { ...DeviceList })
      })
    })
  },
  getFiltered({ commit }, { regency, province, district }) {
    return new Promise((resolve, reject) => {
      const param = {
        status: `devices?regency_id=${regency}&province_id=${province}&district_id=${district}&limit=-1`,
      }
      useRevamp.get(param).then(response => {
        const DeviceList = {
          rows: response.data.responseObject.data,
        }
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setFilteredData', { ...DeviceList })
      })
    })
  },
  getDeviceList({ commit }) {
    const param = { status: 'master/devices?status=UI' }
    useIPA.get(param).then(response => {
      const device = {
        rows: response.data.data,
        pages: [10, 25, 50, 150],
      }
      commit('setDataDeviceList', { ...device })
    })
  },
  getFilteredDeviceList({ commit }, {
    province_id = undefined,
    regency_id = undefined,
    district_id = undefined,
    site_id = undefined,
    area_id = undefined,
    location_id = undefined,
    device_type_id = undefined,
    service_status = undefined,
    start_date = undefined,
    end_date = undefined,
    status = undefined,
    search = undefined,
    page = 1,
    perPage = 10,
  }) {
    return new Promise((resolve, reject) => {
      const param = {
        status: 'master/devices',
        params: {
          device_province_id: province_id,
          device_regency_id: regency_id,
          orderBy: { id: 'desc' },
          device_district_id: district_id,
          device_type_id,
          status,
          page,
          device_site_id: site_id,
          service_status,
          // device_area_id: area_id,
          // device_location_id: location_id,
          search,
          service_start_date_range: start_date,
          service_end_date_range: end_date,
          limit: perPage,
        },
      }
      useIPA.get(param).then(response => {
        const DeviceList = {
          rows: response.data.data,
        }
        const { pagination } = response.data
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data.data)
        }
        commit('setFilteredDeviceData', { ...DeviceList })
        commit('setPagination', pagination)
      })
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/devices/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  getBySerial({ commit }, serialNumber) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device/data/serial/${serialNumber}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  checkBySerialNumber({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/devices/check-serial-number/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const {
        created_at, updated_at, deleted_at, installation_date, last_get_data, last_online_device, last_send_data,
        ...filteredFormData
      } = formData
      const rawData = {
        ...filteredFormData,
        device_type_id: formData.select_1,
        code: formData.text_2,
        name: formData.text_2,
        note: formData.textarea_1,
        serial_number: formData.text_3,
        service_start_date: new Date(formData.service_start_date),
        service_end_date: new Date(formData.service_end_date),
        update_interval: Number(formData.update_interval),
      }
      const param = { rawData, url: 'internal/master/devices', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-device' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  formUpdateService({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        devices_id: formData.deviceId,
        data: {
          service_status: formData.serviceStatus,
          service_start_date: new Date(formData.serviceStartDate),
          service_end_date: new Date(formData.serviceEndDate),
        },
      }
      const param = { rawData, url: 'internal/master/devices/bulk-update', id: null }
      useIPA.postput(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/devices', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getAllFormula({ commit }) {
    const param = { status: 'master/device/formulas/status/AC' }
    useIPA.get(param).then(response => {
      const device = {
        rows: response.data.data,
        pages: [10, 25, 50, 150],
      }
      commit('setDataFormula', { ...device })
    })
  },
  getByIdFormula({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device/formula/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPutFormula({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        device_id: formData.select_1,
        condition: formData.text_1,
        operator: formData.text_2,
        value: formData.text_3,
      }
      const param = { rawData, url: 'internal/master/device/formula', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-device-formula' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  removeFormula({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/device/formula', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getAllValue({ commit }, params) {
    const param = { status: 'master/device-values', params }
    useIPA.get(param).then(response => {
      const device = { rows: response.data.data }
      const { pagination } = response.data
      commit('setDataValue', { ...device })
      commit('setPaginationValue', pagination)
    })
  },
  getByIdValue({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device-values/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPutValue({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        device_id: formData.select_1,
        name: formData.text_1,
        description: formData.text_2,
      }
      const param = { rawData, url: 'internal/master/device-values', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-device-value' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  removeValue({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/device-values', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  getAllKey({ commit }, params) {
    const param = { status: 'master/device-keys?status=AC', params }
    useIPA.get(param).then(response => {
      const device = { rows: response.data.data }
      const { pagination } = response.data
      commit('setDataKey', { ...device })
      commit('setPaginationKey', pagination)
    })
  },
  getByIdKey({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/device-keys/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPutKey({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        device_value_id: formData.select_1,
        key: formData.text_1,
        value: formData.text_2,
        status: 'AC',
      }
      const param = { rawData, url: 'internal/master/device-keys', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'project-device-key' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  removeKey({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/device-keys', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  updateDeviceItems({ commit }, devices) {
    commit('SET_DEVICE_ITEMS', devices)
  },
}

// mutations
const mutations = {
  setData(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.items = device.rows
    state.totalRows = device.pagination.total_items
    state.totalActive = device.rows.filter(
      f => f.status == 'IN',
    ).length
    state.totalOffline = device.rows.filter(
      f => f.status == 'ER',
    ).length
    state.totalError = device.rows.filter(
      f => f.status == 'FL',
    ).length
    state.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') {
          option.is_check = false
          option.value = device.rows[i][key]
        } else if (key === 'code') {
          option.title = `${device.rows[i][key]} - ${device.rows[i].serial_number}`
        } else if (key === 'id') {
          option.oid = device.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setFilteredData(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.filteredDevices = device.rows
    state.filteredOptions = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') {
          option.value = device.rows[i][key]
        } else if (key === 'code') {
          option.title = `${device.rows[i][key]} - ${device.rows[i].serial_number}`
        } else if (key === 'id') {
          option.oid = device.rows[i][key]
        }
      }
      state.filteredOptions.push({ ...option })
    }
  },
  setFilteredDeviceData(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.deviceItems = device.rows.map(item => ({ ...item, is_check: false }))
    state.totalRows = device.rows.length
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
  setDataDeviceList(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.items = device.rows
    state.totalRows = device.rows.length
    state.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'device_id') {
          option.value = device.rows[i][key]
        } else if (key === 'device_code') {
          option.title = `${device.rows[i][key]} - ${device.rows[i].device_serial_number}`
        } else if (key === 'device_id') {
          option.oid = device.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setDataFormula(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.formula.items = device.rows
    state.formula.totalRows = device.rows.length
    state.formula.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') {
          option.value = device.rows[i][key]
        } else if (key === 'name') {
          option.title = device.rows[i][key]
        } else if (key === 'id') {
          option.oid = device.rows[i][key]
        }
      }
      state.formula.options.push({ ...option })
    }
  },
  setDataValue(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.value.items = device.rows
    state.value.totalRows = device.rows.length
    state.value.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') {
          option.value = device.rows[i][key]
        } else if (key === 'name') {
          option.title = device.rows[i][key]
        } else if (key === 'id') {
          option.oid = device.rows[i][key]
        }
      }
      state.value.options.push({ ...option })
    }
  },
  SET_DEVICE_ITEMS(state, devices) {
    state.deviceItems = devices
  },
  setDataKey(state, device) {
    device.rows.forEach((element, index) => {
      element.no = index + 1
    })
    state.key.items = device.rows
    state.key.totalRows = device.rows.length
    state.key.options = []
    for (let i = 0; i < device.rows.length; i++) {
      const option = []
      for (const key in device.rows[i]) {
        if (key === 'id') {
          option.value = device.rows[i][key]
        } else if (key === 'name') {
          option.title = device.rows[i][key]
        } else if (key === 'id') {
          option.oid = device.rows[i][key]
        }
      }
      state.key.options.push({ ...option })
    }
  },
  setPaginationKey(state, pagination) {
    state.key.perPage = pagination.limit
    state.key.totalRows = pagination.total_items
  },
  setPaginationValue(state, pagination) {
    state.value.perPage = pagination.limit
    state.value.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
